import { render } from "./RebateSet.vue?vue&type=template&id=5ed84673"
import script from "./RebateSet.vue?vue&type=script&lang=js"
export * from "./RebateSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__